import { useEffect, useState } from 'react';
import { useAuth } from '../auth/useAuth';
import useLecutre from '../leacture-detail/useLecture';
import firestoreService from '../../services/firestoreService';

export const CORRECTION_TYPES = [
  { key: 'reading', field: 'reading_corrections', label: '독해력' },
  { key: 'thinking', field: 'thinking_corrections', label: '사고력' },
  { key: 'expressiveness', field: 'expression_corrections', label: '표현력' },
  { key: 'underscore', field: 'underline_corrections', label: '밑줄' },
];

const WEAKNESS_PATTERNS = [
  { label: '논제·논지', words: ['논제', '논지', '이탈'] },
  { label: '근거', words: ['근거', '뒷받침', '예시'] },
  { label: '표현', words: ['비문', '어휘', '문장', '표현'] },
  { label: '독해', words: ['독해', '지문', '오독'] },
  { label: '구성', words: ['문단', '구성', '개요', '구조'] },
];

const textOf = (item) => {
  if (!item) return '';
  if (typeof item === 'string') return item;
  return item.content || item.correction || '';
};

const collectTexts = (data) => {
  if (!data) return [];
  return CORRECTION_TYPES.flatMap((type) =>
    (data[type.field] || [])
      .map((item) => ({ type: type.label, text: textOf(item) }))
      .filter((item) => item.text)
  );
};

export const useStudyOverview = () => {
  const { user } = useAuth();
  const { lectureList, loaded } = useLecutre();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const lectures = Array.isArray(lectureList) ? lectureList : [];
    if (!user?.uid || !loaded) {
      if (!user?.uid) setLoading(false);
      return undefined;
    }

    let cancelled = false;

    const load = async () => {
      setLoading(true);
      const next = [];

      for (const lecture of lectures) {
        const [writing, feedback] = await Promise.all([
          firestoreService.getDocument(`LectureProgress/${lecture.id}/LectureWriting`, user.uid),
          firestoreService.getDocument(`LectureProgress/${lecture.id}/LectureFeedback`, user.uid),
        ]);
        const data = writing.success ? writing.data : null;
        const counts = Object.fromEntries(
          CORRECTION_TYPES.map((type) => [type.key, (data?.[type.field] || []).length])
        );
        const texts = collectTexts(data);
        const weaknesses = WEAKNESS_PATTERNS.map((pattern) => {
          const hits = texts.filter((item) => pattern.words.some((word) => item.text.includes(word)));
          return {
            label: pattern.label,
            count: hits.length,
            sample: hits[0] ? hits[0].text.replace(/\s+/g, ' ').slice(0, 90) : '',
          };
        }).filter((item) => item.count > 0);

        next.push({
          id: lecture.id,
          name: lecture.name || '이름 없는 문제',
          university: lecture.university || lecture.univ || lecture.school || '',
          year: lecture.year ? String(lecture.year) : lecture.exam_year ? String(lecture.exam_year) : '',
          track: lecture.track || lecture.field || lecture.category || '',
          counts,
          total: Object.values(counts).reduce((sum, count) => sum + count, 0),
          hasAnswer: Boolean(data?.writing_content && String(data.writing_content).trim()),
          teacherFeedback: feedback.success ? feedback.data?.teacher_feedback || '' : '',
          weaknesses,
        });
      }

      if (!cancelled) {
        setRows(next);
        setLoading(false);
      }
    };

    load();
    return () => {
      cancelled = true;
    };
  }, [user?.uid, lectureList, loaded]);

  return { rows, loading };
};
